module.exports = __webpack_public_path__ + "static/media/bg7.36a95805.png";